import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';
import { SearchIcon } from '../shared/icons';

interface SearchBoxProps {
  readonly placeholder: string
  setSearchValue(name: string): void
}

export default function SearchBox({ placeholder, setSearchValue }: SearchBoxProps) {
  return (
    <Paper
      component="form"
      sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', maxWidth: 400, border: '1px solid #000000' }}
    >
      <InputBase
        sx={{ ml: 1, flex: 1 }}
        placeholder={placeholder}
        inputProps={{ 'aria-label': 'search-text' }}
        onChange={e => setSearchValue(e.currentTarget.value)}
      />
      <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
        <SearchIcon />
      </IconButton>
    </Paper>
  );
}